const { displayMessage } = require("../services/helper");

module.exports = {
    PORTUGUESE: { description: displayMessage('PORTUGUESE'), code: 1 },
    ENGLISH: { description: displayMessage('ENGLISH'), code: 2 },
    SPANISH: { description: displayMessage('SPANISH'), code: 3 },
    FRENCH: { description: displayMessage('FRENCH'), code: 4 },
}


